import BaseDialog from 'customer-data-ui-utilities/dialog/BaseDialog';
import I18n from 'I18n';
import { INSERT_HUBSPOT_VIDEO } from 'rich-text-lib/constants/usageTracking';
import { VideoPanel } from 'video-components-external/components/VideoPanel';
import { buildVideoSharePageUrl } from '../prosemirror/commands/video/buildVideoSharePageUrl';
import { useFetchEmailTrackingDomain } from '../prosemirror/commands/video/videoHooks';
import { Tracker } from '../utils/usageTracker';
import GoVideoContainer from './GoVideoContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoModalTypes = {
  INSERT_VIDEO_HUBSPOT: 'insert-video-hubspot',
  INSERT_VIDEO_VIDYARD: 'insert-video-vidyard'
};
const GoVideoDialog = props => {
  const {
    modalType
  } = props;
  const isHubSpotVideoInsert = modalType === VideoModalTypes.INSERT_VIDEO_HUBSPOT;
  const {
    domain
  } = useFetchEmailTrackingDomain(!isHubSpotVideoInsert);
  if (isHubSpotVideoInsert) {
    return /*#__PURE__*/_jsx(VideoPanel, {
      panelType: "PICKER",
      shouldEncodeToHlsOnInsert: false,
      onSelect: video => {
        var _props$onChange;
        const url = buildVideoSharePageUrl(video.videoId, domain);
        (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, {
          url,
          thumbnailSrc: video.thumbnailUrl,
          videoTitle: video.title
        });
        Tracker.track('prosemirrorVideo', {
          action: INSERT_HUBSPOT_VIDEO,
          method: 'toolbar',
          watchPageUrl: url,
          videoTitle: video.title,
          fileSource: 'hubspot'
        });
      },
      onClose: () => props.onClose()
    });
  }
  return /*#__PURE__*/_jsx(BaseDialog, {
    bodyClassName: "display-flex align-center justify-center",
    onReject: props.onClose,
    showCancelButton: false,
    showConfirmButton: false,
    title: I18n.text('draftPlugins.goVideoModal.title'),
    width: 625,
    size: "short",
    children: /*#__PURE__*/_jsx(GoVideoContainer, {
      isInServiceHub: props.isInServiceHub
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function | undefined' is not assignable to t... Remove this comment to see the full error message
      ,
      onChange: props.onChange
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function' is not assignable to type '(...arg... Remove this comment to see the full error message
      ,
      onClose: props.onClose
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Function | undefined' is not assignable to t... Remove this comment to see the full error message
      ,
      onConfirm: props.onConfirm
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type 'object |... Remove this comment to see the full error message
      ,
      trackingHandlers: props.trackingHandlers,
      recipientEmail: props.recipientEmail,
      isInlineVideo: props.isInlineVideo,
      showTitleCheckBox: props.showTitleCheckBox
    })
  });
};
export default GoVideoDialog;